import React from "react";
import "../Styles/styles.css";


const Press = () => (
    <div className="container">
        <div className="section-title">
            <h2>TRAC<span className="text-lowercase">e</span></h2>
        </div>
        <div className="text-center">
            <p className="text-muted">A comprehensive Risk, Audit and Compliance Testing System</p>
        </div>
        <div className="card shadow p-4">
            <h5 className="text-primary fw-bold">
                MMCS is pleased to announce the availability of TRACe for Sage Intacct users.
            </h5>
            <p>
                MultiMedia Computer Systems (MMCS) is a leading solution provider based in Bangalore, India.
                The company is committed to creating solutions that enable the scanning, storing, archival,
                and retrieval of documents, as well as effortless document sharing between multiple workgroups.
            </p>

            <p>
                TRACe is a web-based tool for auditors, inspectors, and regulators. By using TRACe, auditors automatically comply
                with ISO’s standard Plan-Do-Check-Act methodology. The flexible design enables auditors to define, plan, and execute audits across various domains.
            </p>

            <p>
                TRACe modules include Governance, Risk, Audit, Compliance, Data Capture and Selection, and Branch Continuous Monitoring.
                Both enterprise and cloud versions of the product are available.
            </p>

            <p>
                The product is integrated with the Sage Intacct accounting solution and is listed in the Sage Intacct Marketplace.
                In addition to auditing Accounts maintained by Sage Intacct, auditors can also use it as a general-purpose auditing package.
            </p>

            <h5 className="mt-4">Advantages for Auditors:</h5>
            <ul className="list-group list-group-flush">
                <li className="list-group-item"><strong>TRACeability:</strong> Ability to trace back issues to associated functions.</li>
                <li className="list-group-item">System ensures audit functions are carried out in line with international standards.</li>
                <li className="list-group-item">Ability to communicate with both auditor and auditee.</li>
                <li className="list-group-item">Plan, execute, and follow the audit functions while ensuring a standardized working procedure across team members.</li>
                <li className="list-group-item">Create comprehensive work papers with relevant evidence.</li>
            </ul>

            <p className="mt-4">
                Additional details of TRACe are available at: <a href="https://www.traceaudit.com" target="_blank" rel="noopener noreferrer">www.traceaudit.com</a>
            </p>

            <blockquote className="blockquote mt-3 p-3 bg-light border-start border-primary ps-3">
                <p>
                    “The Sage Intacct Marketplace provides significant benefit to our customers by identifying integrated applications that substantiate the promise of our Best-in-Class strategy,” said Chris Rose, Vice President of Business Development, Sage Intacct. “We welcome MultiMedia Computer Systems as a Marketplace Partner and look forward to the measurable benefits for joint customers.”
                </p>
            </blockquote>
        </div>
    </div>
);

export default Press;
